var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-4 d-flex align-items-center" }, [
        _c("div", { staticClass: "content" }, [
          _c("p", { staticClass: "h2 font-weight-bold" }, [
            _vm._v(_vm._s(_vm.headline))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.listEntries, function(entry) {
            return _c("p", { staticClass: "size-18 mb-0" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "15",
                    height: "10",
                    viewBox: "0 0 15 10"
                  }
                },
                [
                  _c("polygon", {
                    attrs: {
                      fill: "#0090BA",
                      "fill-rule": "evenodd",
                      points:
                        "5.269 18 .258 12.988 1.756 11.489 5.269 14.979 12.763 8 14.262 9.499",
                      transform: "translate(0 -8)"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "ml-1" }, [_vm._v(_vm._s(entry.text))])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-lg-3 d-flex align-items-center justify-content-end"
        },
        [
          _c(
            "a",
            { staticClass: "btn btn-secondary", attrs: { href: _vm.btnUrl } },
            [
              _vm._v(
                "\n              " + _vm._s(_vm.btnText) + "\n            "
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }